<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <h1 class="page__title">{{$t(titlePage)}}</h1>   
            <!-- Title page  -->
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer
                fluid
                class="p-0"
            >
                <!-- Filter -->
                <CRow class="justify-content-end p-2 mb-4">
                    <CCol md="6">
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields 
                            :fields="tables.delivery_origins.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12">
                        <CCard>
                            <CCardHeader class="object-header">
                                <CRow class="p-2 m-0">
                                    <CCol md="11" sm="12">
                                        <h5 class="text-gray-50">
                                            {{ $t("table_delivery_by_origins_description") }}
                                        </h5>
                                    </CCol>
                                    <CCol md="1" sm="12">
                                        <TableSettings
                                            :allFields="tables.delivery_origins.allFields"
                                            :activeFields.sync="tables.delivery_origins.fields"
                                        />
                                    </CCol>
                                </CRow>
                            </CCardHeader>
                            <CCardBody>
                                <!-- Table delivery_campaigns -->
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.delivery_origins.items"
                                    :fields="traslateLabels(tables.delivery_origins.fields)"
                                    :columnFilterValue.sync="
                                        tables.delivery_origins.columnFilterValue
                                    "
                                    :sorterValue.sync="tables.delivery_origins.sorterValue"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="
                                        tables.delivery_origins.rows
                                    "
                                    v-bind="tables.delivery_origins"
                                >
                                <template #no-items-view>
                                        <slot name="no-items-view">
                                            <div class="block-no-items section">
                                                    <br />
                                                <h2
                                                    class="section__title text-no-items"
                                                >
                                                    {{
                                                        $t(
                                                            "no-items-text.delivery_campaigns"
                                                        )
                                                    }}                                                    
                                                </h2>
                                            </div>
                                        </slot>
                                    </template>
                                    <template  #input="{ item, index }">
                                        <td class="py-2" >
                                            {{ notRepeatInput(item, index) }}
                                        </td>
                                    </template>
                                    <template #provider="{ item }" >
                                        <td>
                                            <span class="mr-2">
                                                {{ item.provider }}
                                            </span>
                                        </td>
                                    </template>
                                    <template #origin="{ item }">
                                        <td class="py-2">
                                            <span>{{ item.origin }} </span>
                                        </td>
                                    </template>
                                    <template #id_output="{ item }">
                                        <td class="py-2">
                                            {{ item.id_output }}
                                        </td>
                                    </template>
                                    <template #output="{ item }">
                                        <td class="py-2">
                                            {{ item.output }}
                                        </td>
                                    </template>
                                    <template #countryName="{ item }">
                                        <td class="py-2">
                                            {{ item.countryName }}
                                        </td>
                                    </template>
                                    <template #Sents="{ item }">
                                        <td>
                                            {{ item.Sents }}
                                        </td>
                                    </template>
                                    <template #ok="{ item }">
                                        <td>
                                            {{ item.ok }}
                                        </td>
                                    </template>
                                    <template #status_percentOk="{ item }">
                                        <td>
                                            {{ item.status_percentOk + " %" }}
                                        </td>
                                    </template>
                                    <template #ko="{ item }">
                                        <td>
                                            {{ item.ko }}
                                        </td>
                                    </template>
                                    <template #status_percentKo="{ item }">
                                        <td>
                                            {{ item.status_percentKo + " %" }}
                                        </td>
                                    </template>
                                    <template
                                        #duplicate="{ item }"
                                    >
                                        <td>
                                            {{ item.duplicate }}
                                        </td>
                                    </template>
                                    <template
                                        #status_percentDuplication="{ item }"
                                    >
                                        <td>
                                            {{ item.status_percentDuplication + " %"}}
                                        </td>
                                    </template>
                                    <template #error="{ item }">
                                        <td>
                                            {{ item.error }}
                                        </td>
                                    </template>
                                    <template #status_percentError="{ item }">
                                        <td>
                                            {{ item.error + " %"}}
                                        </td>
                                    </template>
                                    <template #sale_price="{ item }">
                                        <td class="py-2">
                                            {{ item.sale_price }}
                                        </td>
                                    </template>
                                    <template #total_sale="{ item }">
                                        <td class="py-2">
                                            {{ item.total_sale }}
                                        </td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="/outgoing.api/deliveryCampaignSalesByOrigins"
                                                :table="tables.delivery_origins"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.delivery_origins.total_pages > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.delivery_origins.page"
                                        :pages="
                                            tables.delivery_origins.total_pages
                                        "
                                        align="center"
                                    />
                                    <CElementCover :opacity="0.8" class="bg-trasparent" v-if="tables.delivery_origins.loading"/>
                                </div>
                                
                            </CCardFooter>                 
                        </CCard>              
                    </CCol>
                </CRow>
            </CContainer>

            <CContainer
                fluid
                class="p-0 assistant"
                v-show="
                    !hasItemsInTable({
                        tableName: 'delivery_origins'
                    })
                "
            >
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import FilterDate from "~/components/FilterDate";
import ChartGauge from "£lement/ChartGauge";
import FilterFields from "~/components/FilterFields";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";

/**
 * Mixins
 */
import modalMixin from "~/mixins/modal.js";
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/**
 * Others
 */
import {
    cilWarning,
    cilPlus,
    cilDataTransferDown,
    cilSettings,
    cilEnvelopeClosed,
    cilArrowThickFromRight
} from "@coreui/icons";
import DeliveryOriginsTable from "./config/tables/delivery_origins";

export default {
    name: "DeliveryCampaignsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin, modalMixin],
    components: {
        FilterDate,
        ChartGauge,
        TableSettings,
        FilterFields,
        ButtonExport
    },
    icons: {
        cilWarning,
        cilPlus,
        cilDataTransferDown,
        cilSettings,
        cilEnvelopeClosed,
        cilArrowThickFromRight
    },
    data() {
        return {
            tables: {
                delivery_origins: DeliveryOriginsTable
            }
        };
    },
    computed: {
    },
    methods: {
        notRepeatInput(item, index){
            if(index != 0){
                var lastInput= this.tables["delivery_origins"].items[index -1].input;
                if( lastInput == item.input ){
                    return "";
                }
            }
            return item.input;
        },
        async updateData() {
            

            await this.updateTable({
                tableName: "delivery_origins",
                url: "/outgoing.api/deliveryCampaignSalesByOrigins"
            });
            
            await this.loadCountryInTable({
                tableName: "delivery_origins",
                fielCountryName: "country_id"
            });
            this.updatePageLoading(false);

        }
    },
    async mounted() {
        this.loadCountries();
        this.updatePageLoading(false);
        this.tables["delivery_origins"].loading = false;
        // await this.updateData();
    }
};
</script>

<style scoped lang="scss">
.icon-warning {
    color: #f9b115;
    margin-left: 0.5em;
    margin-bottom: 0.4em;
}
.table-responsive {
    overflow-x: none;
}
.btn-export-table {
    /* position: absolute;
        right: 2%; */
    background: none;
    color: black;
    border: none;
    box-shadow: none;
    &:hover {
        border: none;
        box-shadow: none;
    }
    &:active {
        background: none;
    }
    &:focus {
        border: none;
        outline: none;
    }
}
</style>
